import { render } from "./Product_preview.vue?vue&type=template&id=3e4a86ca&scoped=true"
import script from "./Product_preview.vue?vue&type=script&lang=js"
export * from "./Product_preview.vue?vue&type=script&lang=js"

import "./Product_preview.vue?vue&type=style&index=0&id=3e4a86ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4a86ca"]])

export default __exports__